<div class="track-my-location-container" style="background-color: #fff;">
  <div class="track-my-location">

    <div class="header col-12 md:col-12 lg:col-12 sm:col-12">
      <div class="col-6 md:col-12 lg:col-6 sm:col-12 contact-info">
        <a href="" target="_blank">
          <img width="200" src="/assets/images/temp/MI_black_logo.png">
        </a>
      </div>
    </div>
    <div class=" col-nopad col-12 md:col-12 lg:col-12">
      <div class="seperator"></div>
    </div>

    <div class="col-12 md:col-12 lg:col-12" style="padding: 20px; line-height: 2;">
    <div class="col-2 p-0" *ngIf="showLanguageDropdown">
      <p-select [options]="languageOptions" appendTo="body" placeholder="Select Language"
      [ngStyle]="{'min-width': '170px'}" [(ngModel)]="selectedLanguage" [ngModelOptions]="{standalone: true}">
    </p-select>
  </div>

  <div *ngIf="selectedLanguage === 'en'">

      <h1 class="p-m-0">Privacy Policy</h1>
      <p><strong>Last Updated: February 19, 2026</strong></p>

      <h2>1. Introduction</h2>
      <p>Welcome to CityRide ("we," "our," or "us"). We are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our transportation services, mobile application, and website.</p>

      <h2>2. Information We Collect</h2>
      <h3>2.1 Personal Information</h3>
      <p>We may collect the following personal information:</p>
      <ul>
        <li>Name, email address, phone number</li>
        <li>Payment information (credit card details, billing address)</li>
        <li>Profile information and preferences</li>
        <li>Government-issued identification for verification purposes</li>
      </ul>

      <h3>2.2 Location Information</h3>
      <p>When you use our services, we collect real-time location data to:</p>
      <ul>
        <li>Match you with nearby drivers</li>
        <li>Provide accurate pickup and drop-off services</li>
        <li>Improve route optimization</li>
        <li>Enhance safety and security</li>
      </ul>

      <h3>2.3 Usage Information</h3>
      <p>We automatically collect information about how you interact with our services, including:</p>
      <ul>
        <li>Device information (model, operating system, unique identifiers)</li>
        <li>Log data (IP address, access times, pages viewed)</li>
        <li>Cookies and similar tracking technologies</li>
      </ul>

      <h2>3. How We Use Your Information</h2>
      <p>We use the collected information for the following purposes:</p>
      <ul>
        <li>To provide, maintain, and improve our transportation services</li>
        <li>To process bookings and payments</li>
        <li>To communicate with you about your trips, promotions, and updates</li>
        <li>To ensure safety and security of our services</li>
        <li>To comply with legal obligations</li>
        <li>To personalize your experience</li>
        <li>To analyze usage patterns and improve our services</li>
      </ul>

      <h2>4. Information Sharing and Disclosure</h2>
      <p>We may share your information in the following circumstances:</p>
      <ul>
        <li><strong>With Drivers:</strong> We share your name, phone number, and pickup location with drivers assigned to your trip</li>
        <li><strong>Service Providers:</strong> We may share information with third-party service providers who assist us in operating our business</li>
        <li><strong>Legal Requirements:</strong> We may disclose information if required by law or to protect our rights and safety</li>
        <li><strong>Business Transfers:</strong> In the event of a merger, acquisition, or sale of assets, your information may be transferred</li>
      </ul>

      <h2>5. Data Security</h2>
      <p>We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet is 100% secure.</p>

      <h2>6. Your Rights and Choices</h2>
      <p>You have the right to:</p>
      <ul>
        <li>Access and update your personal information</li>
        <li>Request deletion of your account and data</li>
        <li>Opt-out of marketing communications</li>
        <li>Control location sharing through your device settings</li>
        <li>Request a copy of your data</li>
      </ul>

      <h2>7. Cookies and Tracking Technologies</h2>
      <p>We use cookies and similar technologies to enhance your experience, analyze usage, and assist with marketing efforts. You can control cookies through your browser settings.</p>

      <h2>8. Children's Privacy</h2>
      <p>Our services are not intended for individuals under the age of 18. We do not knowingly collect personal information from children.</p>

      <h2>9. International Data Transfers</h2>
      <p>Your information may be transferred to and processed in countries other than your country of residence. We ensure appropriate safeguards are in place for such transfers.</p>

      <h2>10. Changes to This Privacy Policy</h2>
      <p>We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date.</p>

      <h2>11. Contact Us</h2>
      <p>If you have any questions about this Privacy Policy, please contact us:</p>
      <ul>
        <li>Email: privacy&#64;cityride.com</li>
        <li>Phone: +1 (555) 123-4567</li>
        <li>Address: 123 Transport Street, City, State 12345</li>
      </ul>
    </div>

    <div *ngIf="selectedLanguage === 'fr'">
      <h1>Politique de confidentialité</h1>
      <p><strong>Dernière mise à jour: 19 février 2026</strong></p>

      <h2>1. Introduction</h2>
      <p>Bienvenue sur CityRide ("nous," "notre," ou "nous"). Nous sommes déterminés à protéger votre vie privée et à garantir la sécurité de vos informations personnelles. Cette Politique de confidentialité explique comment nous collectons, utilisons, divulguons et protégeons vos informations lorsque vous utilisez nos services de transport, notre application mobile et notre site web.</p>

      <h2>2. Informations que nous collectons</h2>
      <h3>2.1 Informations personnelles</h3>
      <p>Nous pouvons collecter les informations personnelles suivantes :</p>

      <h3>2.2 Informations de localisation</h3>
      <p>Lorsque vous utilisez nos services, nous collectons des données de localisation en temps réel pour :</p>
      <ul>
        <li>Vous mettre en relation avec des conducteurs à proximité</li>
        <li>Vous fournir des services de prise en charge et de dépôt</li>
        <li>Améliorer l'optimisation des itinéraires</li>
        <li>Améliorer la sécurité et la sécurité</li>
      </ul>
    </div>

  </div>
</div>
</div>

